import React from "react";
import { Button, ChevronEndMediumIcon, Flex, Loader, Text } from "@fluentui/react-northstar";
import styles from "./taskDetailsItem.module.scss";
import classNames from "classnames";
import { TeamsTextWeight } from "shared/types/TeamsTextWeight";
import { StringLiteralLike } from "typescript";

interface TaskDetailsItemProps {
    label: string;
    primaryText: string;
    primaryTextColor?: string;
    primaryTextWeight?: TeamsTextWeight;
    secondaryText?: string;
    isLoading?: boolean;
    isMobile?: boolean;
    additionalClassName?: string;
    onlyDescription?: boolean;
    placeholder?: string;

    isMultiline?: boolean;
    values?: string[];

    onClick?: () => void;
}

const TaskDetailsItem: React.FC<TaskDetailsItemProps> = (props: TaskDetailsItemProps) => {
    const renderLoader = () => <Loader className={styles.inlineLoader} size="smallest" inline />;

    const renderPrimaryContent = () => {
        if (props.isMultiline && props.values && props.values.length > 0) {
            const readOnlyLines = props.values.map((value, index, array) => (
                <Text
                    key={value}
                    className={classNames({ [styles.primaryText]: props.onClick })}
                    disabled={props.isLoading}
                    color={props.primaryTextColor}
                    weight={props.primaryTextWeight}
                >
                    {index !== array.length - 1 ? `${value},` : value}
                </Text>
            ));
            return (
                <Flex onClick={!props.isLoading ? props.onClick : () => false}>
                    <Flex column>{readOnlyLines}</Flex>
                    {props.isLoading && renderLoader()}
                </Flex>
            );
        }

        return (
            <Text
                disabled={props.isLoading}
                color={props.primaryTextColor}
                weight={props.primaryTextWeight}
                onClick={!props.isLoading ? props.onClick : () => false}
                className={classNames({ [styles.primaryText]: props.onClick })}
            >
                {props.primaryText}
                {props.isLoading && renderLoader()}
            </Text>
        );
    };

    return (
        <Flex className={classNames(props.additionalClassName, props.isMobile && styles.wrapper)}>
            <Flex className={styles.label}>
                <Text content={props.label} weight={props.primaryTextWeight ?? "semibold"} />
            </Flex>
            <Flex column={!props.isMobile} space="between">
                <Flex
                    column={!props.isMobile}
                    className={classNames({
                        [styles.detailsTextWrapper]: props.isMobile,
                        [styles.descriptionWrapper]: props.onlyDescription,
                    })}
                >
                    {renderPrimaryContent()}
                    {props.secondaryText && props.isMobile ? (
                        <Text className={styles.secondaryText}>{`(${props.secondaryText})`}</Text>
                    ) : (
                        <Text>{props.secondaryText}</Text>
                    )}
                </Flex>
                {props.isMobile && !props.onlyDescription && (
                    <Button iconOnly={true} icon={<ChevronEndMediumIcon size="medium" />} onClick={props.onClick} />
                )}
            </Flex>
        </Flex>
    );
};

export default TaskDetailsItem;
